import NP from 'number-precision'
import dayjs from 'dayjs'

export const MONTH_INTERVAL_IN_MINUTE = 60 * 24 * 30
export const DAY_INTERVAL_IN_MINUTE = 24 * 60
export const HOUR_IN_MINUTE = 60

interface MoneyFormOptions {
  /** 精度 */
  precision?: number
  /** 四舍五入 */
  rounding?: boolean
}

export function moneyForm(obj: number | undefined, options: MoneyFormOptions = {}): string {
  if (obj === undefined || obj === 0)
    return '0'

  const { precision = 2, rounding = false } = options
  const temp = NP.divide(obj, 100)
  if (rounding)
    return `${NP.round(temp, precision)}`
  else return temp.toFixed(precision)
}

export function moneyTo(val: number, options: MoneyFormOptions = {}) {
  if (!val)
    return 0

  const { precision = 2, rounding = false } = options
  let temp
  if (rounding)
    temp = NP.round(+val, precision)
  else temp = (+val).toFixed(precision)

  return NP.times(temp, 100)
}

/**
 * HH:mm 解析成分钟数
 * @param obj
 * @returns
 */
export function date2Minute(obj: string) {
  if (!obj)
    return 0
  const [hour, minute] = obj.split(':')
  return +hour * 60 + +minute
}

/**
 * 格式化为可读日期
 * @param data 日期
 */
export const YYYYMMDDHHmmss = function (data: dayjs.ConfigType | undefined) {
  if (!data)
    return ''
  return dayjs(data).format('YYYY-MM-DD HH:mm:ss')
}

export const YYYYMMDD = function (data: dayjs.ConfigType | undefined) {
  if (!data)
    return ''
  return dayjs(data).format('YYYY-MM-DD')
}

/**
 * 分钟数字格式化为 HH:mm
 */
export function minute2Date(obj: number) {
  if (obj === 0)
    return '00:00'
  const hourStr = Math.floor(obj / 60)
  const minuteStr = obj % 60
  return `${hourStr.toString().padStart(2, '0')}:${minuteStr.toString().padStart(2, '0')}`
}

/**
 * 格式化为可读日期
 * @param data 日期
 * @returns
 */
export const date = function (data: dayjs.ConfigType | undefined) {
  if (!data)
    return ''
  return dayjs(data).format('YYYY-MM-DD HH:mm:ss')
}

export function s_date(data: dayjs.ConfigType | undefined) {
  if (!data)
    return ''
  return dayjs(data).format('YYYY-MM-DD')
}

/**
 * 格式化分钟为可读时间
 * @param data 分钟
 * @returns 格式化后的时间
 */
export function minuteForm(data: number) {
  let obj = ''
  if (!data)
    return '0分钟'

  if (data < HOUR_IN_MINUTE)
    return `${data}分钟`

  const month = Math.floor(data / MONTH_INTERVAL_IN_MINUTE)
  data -= month * MONTH_INTERVAL_IN_MINUTE
  const day = Math.floor(data / DAY_INTERVAL_IN_MINUTE)
  data -= day * DAY_INTERVAL_IN_MINUTE
  const hour = Math.floor(data / HOUR_IN_MINUTE)
  data -= hour * HOUR_IN_MINUTE

  const minute = data % HOUR_IN_MINUTE

  obj += month > 0 ? `${month}月` : ''
  obj += day > 0 ? `${day}天` : ''
  obj += hour > 0 ? `${hour}小时` : ''
  obj += minute > 0 ? `${minute}分钟` : ''
  return obj
}

export function getDateFormatBy(dateType: 'day' | 'month' | 'year') {
  const map = {
    day: 'YYYY-MM-DD',
    month: 'YYYY-MM',
    year: 'YYYY',
  }
  return map[dateType]
}

export function numForm(val: number) {
  if (typeof val !== 'number' || Number.isNaN(val))
    return '异常'
  return new Intl.NumberFormat().format(val)
}

export function dateFilterForm(date?: any) {
  if (!date || date.length === 0)
    return date

  const [start, end] = date
  return {
    $gte: dayjs(start).toDate().getTime(),
    $lte: dayjs(end).toDate().getTime(),
  }
}

export function regexFilterForm(val: string, options?: { all?: boolean }) {
  if (options?.all)
    return { $regex: `^.*${val.trim()}`, $options: 'i' }

  return { $regex: `^${val.trim()}`, $options: 'i' }
}

export const filter = {
  moneyForm,
  moneyTo,
  date2Minute,
  minute2Date,
  dateForm: date,
  minuteForm,
  getDateFormatBy,
  numForm,
  dateFilterForm,
  regexFilterForm,
}
